import React, { Component } from 'react';

import { AuthConstraintAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType, ContainerProvider } from '@philips-emr/tws-core';
import { arrayOf, bool, element, list, oneOf, oneOfType, string, tuple } from '@philips-emr/tws-core/lib/component/prop-types';
import { AuthenticationService } from '@philips-emr/tws-core/lib/services';
import { Logical } from '@philips-emr/tws-core/lib/services/auth/permission-matcher';
import { enumValues, getLostProps, propagateProps } from '@philips-emr/tws-utils';

const acceptedTypes = enumValues(ComponentType);

@AwesomeComponent({ type: ComponentType.BEHAVIOR, api: AuthConstraintAPI })
class AuthConstraint extends Component {

  static propTypes = {
    uuid: string,
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    claims: tuple([string.placeholder('claim'), string.placeholder('value')]).group('constraint'),
    logical: oneOf(enumValues(Logical)).group('logical'),
    permissions: list.group('constraint'),
    redirect: bool,
  };

  static defaultProps = {
    claims: {},
    logical: Logical.AND,
    permissions: [],
  };

  matchClaims() {
    const { claims } = this.props;

    const keys = Object.keys(claims);
    return keys.every(key => {
      const value = AuthenticationService.getJWTToken().claims[key];
      return claims[key] == value;
    });
  }

  hasPermission() {
    const { permissions, claims, logical } = this.props;

    if (!AuthenticationService.isAuthenticated()) {
      return false;
    }

    const hasPermissions = AuthenticationService.matchPermissions(permissions, logical);

    switch(logical) {
      case Logical.AND:
        return hasPermissions && AuthenticationService.matchClaims(claims, logical);
      case Logical.OR:
        return hasPermissions || AuthenticationService.matchClaims(claims, logical);
    }

    return false;
  }

  render() {
    const { children, uuid, redirect } = this.props;
    const lostProps = getLostProps(AuthConstraint.propTypes, this.props);

    if (React.Children.count(children) === 0) {
      const Container = ContainerProvider.provide(this);
      return <Container acceptedTypes={acceptedTypes} className="u-expand" uuid={uuid} />;
    }

    const hasPermission = this.hasPermission();

    if (!hasPermission && redirect) {
      AuthenticationService.redirectToLogin();
    }

    if (!hasPermission) {
      return null;
    }

    return <> {propagateProps(children, lostProps)} </>;
  }
}

export default AuthConstraint;
